import { createContext, type Context as ReactContext } from 'react';

import { type Context } from '../types';

export const DialogContext: ReactContext<Context> = createContext<Context>({
	openDialog: () => null,
	closeDialog: () => null,
});
